import AddContactForm from 'components/AddContactForm';
import ContactsTable from 'components/ContactTable';
import React, { useState, useEffect, useRef } from 'react';
import { contactAPI } from 'services/apisService';
import { useLocation } from 'react-router-dom';
import ShowDeleteModal from 'components/Contact/ShowDeleteModal';
import ShowDuplicateModal from 'components/Contact/ShowDuplicateModal';
import ShowImportModal from 'components/Contact/ShowImportModal';
import DownloadReasonModal from 'components/Contact/DownloadReasonModal';
import UserListDropdown from 'components/Contact/UserListDropdown';
import SearchBy from 'components/SearchBy';

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingData, setIsFetchingData] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [showUserTypeDropdown, setShowUserTypeDropdown] = useState(false);
  const [selectedSearchField, setSelectedSearchField] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [searchDate, setSearchDate] = useState('');
  const [activeFilters, setActiveFilters] = useState({});
  const dropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const userTypeDropdownRef = useRef(null);
  const fileInputRef = useRef(null);
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileError, setFileError] = useState('');
  const [isImporting, setIsImporting] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateData, setDuplicateData] = useState(null);
  const [importSuccess, setImportSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));
  const [userName, setUserName] = useState(user?.role);
  const [showUsersDropdown, setShowUsersDropdown] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState('');
  const usersDropdownRef = useRef(null);
  const [showActionsDropdown, setShowActionsDropdown] = useState(false);
  const [showStatusSubDropdown, setShowStatusSubDropdown] = useState(false);
  const [showFollowupCallCalendar, setShowFollowupCallCalendar] = useState(false);
  const [showFollowupMailCalendar, setShowFollowupMailCalendar] = useState(false);
  const [isUpdatingContacts, setIsUpdatingContacts] = useState(false);
  const actionsDropdownRef = useRef(null);
  const statusSubDropdownRef = useRef(null);
  const [followupCallDate, setFollowupCallDate] = useState('');
  const [followupMailDate, setFollowupMailDate] = useState('');
  const [limitt, setLimit] = useState(10); 
  const [totalContacts, setTotalContacts] = useState(0);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

useEffect(() => {
  if (showStatusSubDropdown) {
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = '15px';
  } else {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  return () => {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };
}, [showStatusSubDropdown]);


  const animationStyles = `
    @keyframes slide-in {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    .animate-slide-in {
      animation: slide-in 0.3s ease-out;
    }
  `;



  React.useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = animationStyles;
    document.head.appendChild(styleSheet);
    return () => document.head.removeChild(styleSheet);
  }, []);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    companyName: '',
    title: '',
    location: '',
    source: '',
    leadStatus: '',
    userType: ''
  });

  const searchOptions = [
    { value: 'created_at', label: 'Created At', isDate: true },
    { value: 'nextFollowupCall', label: 'Next Followup Call', isDate: true },
    { value: 'nextFollowupMail', label: 'Next Followup Mail', isDate: true },
    { value: 'name', label: 'Name', isDate: false },
    { value: 'email', label: 'Email', isDate: false },
    { value: 'phone', label: 'Phone', isDate: false },
    { value: 'location', label: 'Location', isDate: false },
    { value: 'companyName', label: 'Company Name', isDate: false },
    { value: 'title', label: 'Title', isDate: false },
    { value: 'status', label: 'Status', isDate: false, isStatus: true },
    { value: 'userType', label: 'User Type', isDate: false, isUserType: true }
  ];

  const statusOptions = [
    { value: 'new', label: 'New' },
    { value: 'attempted_contact', label: 'Attempted Contact' },
    { value: 'follow_up_scheduled', label: 'Follow Up Scheduled' },
    { value: 'interested', label: 'Interested' },
    { value: 'not_interested', label: 'Not Interested' },
    { value: 'wrong_contact', label: 'Wrong Contact' },
    { value: 'converted_to_lead', label: 'Converted to Lead' }
  ];

  const userTypeOptions = [
    { value: 'Vendor', label: 'Vendor' },
    { value: 'Enterprise', label: 'Enterprise' },
    { value: 'FlexpertEnquiry', label: 'Flexpert' }
  ];

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
    if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
      setShowStatusDropdown(false);
    }
    if (userTypeDropdownRef.current && !userTypeDropdownRef.current.contains(event.target)) {
      setShowUserTypeDropdown(false);
    }
    if (usersDropdownRef.current && !usersDropdownRef.current.contains(event.target)) {
      setShowUsersDropdown(false);
    }
    if (actionsDropdownRef.current && !actionsDropdownRef.current.contains(event.target)) {
      setShowActionsDropdown(false);
      setShowStatusSubDropdown(false);
      setShowFollowupCallCalendar(false);
      setShowFollowupMailCalendar(false);
    }
    if (statusSubDropdownRef.current && !statusSubDropdownRef.current.contains(event.target)) {
      setShowStatusSubDropdown(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);

const handleBulkUpdate = async (updateType, value) => {
  const selectedIds = getSelectedContactIds();
  if (selectedIds.length === 0) return;

  setIsUpdatingContacts(true);
  try {
    const payload = {
      ids: selectedIds,
      [updateType]: value
    };

    await contactAPI.updateContactBulk(payload);
    
    fetchContacts(currentPage, activeFilters, limitt);
    
    setShowActionsDropdown(false);
    setShowStatusSubDropdown(false);
    setShowFollowupCallCalendar(false);
    setShowFollowupMailCalendar(false);
    setSelectAll(false);
    
    const updatedContacts = contacts.map(contact => ({
      ...contact,
      selected: false
    }));
    setContacts(updatedContacts);
    
  } catch (error) {
    console.error('Error updating contacts:', error);
    setErrorMessage('Failed to update contacts. Please try again.');
  } finally {
    setIsUpdatingContacts(false);
  }
};

const handleDateSelect = (updateType, date) => {
  handleBulkUpdate(updateType, date);
};

const handleStatusBulkSelect = (status) => {
  handleBulkUpdate('status', status.value);
};

   const fetchContacts = async (page = 1, filters = {}, newLimit = limit) => {
    setIsFetchingData(true);
    try {
      let queryParams = `page=${page}&limit=${newLimit}`;

      const userIdToUse = filters.userId !== null && filters.userId !== undefined 
        ? filters.userId 
        : selectedUserId;
        
      if (userIdToUse && filters.userId !== null) {
        queryParams += `&userId=${userIdToUse}`;
      }
      
      Object.keys(filters).forEach(key => {
        if (filters[key] && key !== 'userId') { 
          queryParams += `&${key}=${filters[key]}`;
        }
      });

      const { data, totalPages: pages, totalContacts: total } = await contactAPI.getContacts(page, newLimit, queryParams);
      
      const formattedContacts = Array.isArray(data) ? data.map(contact => ({
        id: contact.id,
        name: contact.name || '--',
        email: contact.email || '--',
        phone: contact.phone || '--',
        company: contact.companyName || '--',
        userType: contact.userType || '--',
        status: contact.status || '--',
        title: contact.title || '--',
        location: contact.location || '--',
        source: contact.source || '--',
        domainExists: contact.domainExists ?? '--',
        createdAt: contact.created_at || null,
        selected: false
      })) : [];
      
      setContacts(formattedContacts);
      setCurrentPage(page);
      setTotalPages(pages);
      setTotalContacts(total); 
    } catch (error) {
      console.error('Error fetching contacts:', error);
      setContacts([]);
    } finally {
      setIsFetchingData(false);
    }
  };

   const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    fetchContacts(1, activeFilters, newLimit); 
  };

    useEffect(() => {
  const queryParams = new URLSearchParams(location.search);
  const filter = queryParams.get('filter');
  
  if (filter === 'followupcalls') {
    const today = new Date().toISOString().split('T')[0]; 
    const filters = {
      nextFollowupCall: today
    };
    setActiveFilters(filters);
    fetchContacts(1, filters, limitt);
  } else if (filter === 'followupmails') {
    const today = new Date().toISOString().split('T')[0]; 
    const filters = {
      nextFollowupMail: today
    };
    setActiveFilters(filters);
    fetchContacts(1, filters, limitt);
  } else {
    fetchContacts(currentPage, limitt);
  }
}, [location.search]);

  const handlePageChange = (newPage) => {
  fetchContacts(newPage, activeFilters, limitt); 
};

  const handleUserSelect = (user) => {
  setSelectedUserId(user.id);
  setShowUsersDropdown(false);
  const filtersWithUser = { ...activeFilters, userId: user.id };
  fetchContacts(1, filtersWithUser, limitt);
};

  const clearUserFilter = () => {
  setSelectedUserId('');
  setShowUsersDropdown(false);
  setActiveFilters({});
  setSelectedSearchField('');
  setSearchValue('');
  setSearchDate('');
  fetchContacts(1, { userId: null }, limitt); 
};

  const handleSearchFieldSelect = (field) => {
    setSelectedSearchField(field.value);
    setShowDropdown(false);
    setSearchValue('');
    setSearchDate('');
    
    if (field.isStatus) {
      setShowStatusDropdown(true);
    }
    
    if (field.isUserType) {
      setShowUserTypeDropdown(true);
    }
  };

  const handleStatusSelect = (status) => {
    const newFilters = {
      ...activeFilters,
      status: status.value
    };

    setActiveFilters(newFilters);
    setShowStatusDropdown(false);
    fetchContacts(1, newFilters, limitt);
  };

  const handleUserTypeSelect = (userType) => {
    const newFilters = {
      ...activeFilters,
      userType: userType.value
    };

    setActiveFilters(newFilters);
    setShowUserTypeDropdown(false);
    fetchContacts(1, newFilters, limitt);
  };

  const handleSearch = () => {
    if (!selectedSearchField) return;

    const selectedOption = searchOptions.find(opt => opt.value === selectedSearchField);
    const filterValue = selectedOption.isDate ? searchDate : searchValue;

    if (!filterValue) return;

    const newFilters = {
      ...activeFilters,
      [selectedSearchField]: filterValue
    };

    setActiveFilters(newFilters);
    fetchContacts(1, newFilters, limitt);
  };

  const clearFilters = () => {
    setActiveFilters({});
    setSelectedSearchField('');
    setSearchValue('');
    setSearchDate('');
    setShowStatusDropdown(false);
    setShowUserTypeDropdown(false);
    fetchContacts(1, {}, limitt);
  };

  const removeFilter = (filterKey) => {
    const newFilters = { ...activeFilters };
    delete newFilters[filterKey];
    setActiveFilters(newFilters);
    fetchContacts(1, newFilters, limitt);
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    
    const updatedContacts = contacts.map(contact => ({
      ...contact,
      selected: newSelectAll
    }));
    
    setContacts(updatedContacts);
  };

  const handleSelectContact = (id) => {
    const updatedContacts = contacts.map(contact => 
      contact.id === id ? { ...contact, selected: !contact.selected } : contact
    );
    setContacts(updatedContacts);
    
    const allSelected = updatedContacts.every(contact => contact.selected);
    setSelectAll(allSelected && updatedContacts.length > 0);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  
  try {
    const payload = {
      name: formData.name,
      companyName: formData.companyName,
      userType: formData.userType,
      title: formData.title || '',
      location: formData.location || '', 
      source: formData.source || '',
      status: formData.leadStatus || 'new'
    };
    
    if (formData.email && formData.email.trim()) {
      payload.email = formData.email;
    }
    
    if (formData.phone && formData.phone.trim()) {
      payload.phone = formData.phone;
    }
    
    const newContact = await contactAPI.addContact(payload);
    
    const formattedNewContact = {
      id: newContact.id,
      name: newContact.name || '--',
      email: newContact.email || '--',
      phone: newContact.phone || '--',
      company: newContact.companyName || '--',
      userType: newContact.userType || '--',
      status: newContact.status || '--',
      title: newContact.title || '--',
      location: newContact.location || '--',
      source: newContact.source || '--',
      userId: newContact.user?.id,
      createdAt: newContact.created_at || null,
      selected: false
    };
    
    const updatedContacts = [formattedNewContact, ...contacts];
    setContacts(updatedContacts);
    
    resetForm();
    setShowAddModal(false);
    
 } catch (error) {
console.error('Error adding contact:', error);
const apiMessage = error.message || 'Failed to add contact. Please try again.';
setErrorMessage(apiMessage);
}
finally {
    setIsLoading(false);
  }
};

  useEffect(() => {
  if (errorMessage) {
    const timer = setTimeout(() => setErrorMessage(''), 5000);
    return () => clearTimeout(timer);
  }
}, [errorMessage]);

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      companyName: '',
      title: '',
      location: '',
      source: '',
      leadStatus: ''
    });
  };

  useEffect(() => {
    if (showAddModal || showImportModal || showDuplicateModal || showDownloadModal) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '15px'; 
    } else {
      document.body.style.overflow = ''; 
      document.body.style.paddingRight = '';
    }
    return () => {
      document.body.style.overflow = ''; 
      document.body.style.paddingRight = ''; 
    };
  }, [showAddModal, showImportModal, showDuplicateModal, showDownloadModal]);

 const updateContactStatus = async (contactId, newStatus) => {
  try {
    await contactAPI.updateContact(contactId, { status: newStatus });
    
    if (activeFilters.status) {
      fetchContacts(currentPage, activeFilters, limitt);
    } else {
      const updatedContacts = contacts.map(contact => 
        contact.id === contactId ? { ...contact, status: newStatus } : contact
      );
      setContacts(updatedContacts);
    }
    
  } catch (error) {
    console.error('Error updating contact status:', error);
    throw error;
  }
};

  const getSelectedOption = () => {
    return searchOptions.find(opt => opt.value === selectedSearchField);
  };

  const getStatusLabel = (value) => {
    return statusOptions.find(opt => opt.value === value)?.label || value;
  };

  const getUserTypeLabel = (value) => {
    return userTypeOptions.find(opt => opt.value === value)?.label || value;
  };

  const getSelectedContactIds = () => {
    return contacts.filter(contact => contact.selected).map(contact => contact.id);
  };

  const handleDeleteContacts = async () => {
    const selectedIds = getSelectedContactIds();
    if (selectedIds.length === 0) return;
    
    setIsDeleting(true);
    try {
      await contactAPI.deleteContacts(selectedIds);
      
      const updatedContacts = contacts.filter(contact => !contact.selected);
      setContacts(updatedContacts);
      setSelectAll(false);
      setShowDeleteModal(false);
      
      fetchContacts(currentPage, activeFilters, limitt);
      
    } catch (error) {
      console.error('Error deleting contacts:', error);
      setErrorMessage('Failed to delete contacts. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleFileSelect = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileError('');
    
    if (file) {
      if (!file.name.toLowerCase().endsWith('.csv')) {
        setFileError('Please upload .csv file only');
        setSelectedFile(null);
        return;
      }
      
      setSelectedFile(file);
    }
  };

  const handleImportContacts = async () => {
    if (!selectedFile) return;
    
    setIsImporting(true);
    try {
      const response = await contactAPI.importContacts(selectedFile);
      
      setShowImportModal(false);
      setSelectedFile(null);
      setFileError('');
      
      if (response && response.success === true) {
        setImportSuccess(true);
        setTimeout(() => setImportSuccess(false), 3000);
      } else {
        setDuplicateData(response);
        setShowDuplicateModal(true);
      }
      
      fetchContacts(currentPage, activeFilters, limitt);
      
    } catch (error) {
      console.error('Error importing contacts:', error);
      setFileError(error.message || 'Failed to import contacts. Please try again.');
    } finally {
      setIsImporting(false);
    }
  };

  const resetImportModal = () => {
    setSelectedFile(null);
    setFileError('');
    setShowImportModal(false);
  };

  const convertToCSV = (data) => {
    if (!data) return '';
    if (typeof data === 'string') {
      return data;
    }
    
    let csvData = [];
    
    if (Array.isArray(data)) {
      csvData = data;
    }
    else if (data.duplicates && Array.isArray(data.duplicates)) {
      csvData = data.duplicates;
    }
    else if (typeof data === 'object') {
      const possibleKeys = ['data', 'entries', 'rows', 'contacts', 'duplicateEntries'];
      for (const key of possibleKeys) {
        if (data[key]) {
          if (typeof data[key] === 'string') {
            return data[key];
          }
          if (Array.isArray(data[key])) {
            csvData = data[key];
            break;
          }
        }
      }
      
      if (csvData.length === 0) {
        csvData = [data];
      }
    }
    
    if (csvData.length === 0) return '';
    
    const headers = [...new Set(csvData.flatMap(obj => Object.keys(obj)))];
    
    const csvHeaders = headers.join(',');
    
    const csvRows = csvData.map(row => {
      return headers.map(header => {
        const value = row[header] || '';
        return typeof value === 'string' && (value.includes(',') || value.includes('"')) 
          ? `"${value.replace(/"/g, '""')}"` 
          : value;
      }).join(',');
    });
    return [csvHeaders, ...csvRows].join('\n');
  };

  const downloadDuplicates = () => {
    if (!duplicateData) return;
    const csvContent = convertToCSV(duplicateData);

    if (!csvContent) {
      alert('No duplicate data available to download');
      return;
    }
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `duplicate_contacts_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); 
    }
    
    setShowDuplicateModal(false);
    setDuplicateData(null);
    setImportSuccess(true);
    setTimeout(() => setImportSuccess(false), 3000);
  };

  const handleDownloadCSV = async (reason) => {
    setIsDownloading(true);
    try {
      const payload = {
        reason: reason
      };

      const userIdToUse = activeFilters.userId !== null && activeFilters.userId !== undefined 
        ? activeFilters.userId 
        : selectedUserId;
      
      if (userIdToUse) {
        payload.userId = String(userIdToUse);
      }

      // Add other active filters
      Object.keys(activeFilters).forEach(key => {
        if (activeFilters[key] && key !== 'userId') {
          payload[key] = activeFilters[key];
        }
      });

      await contactAPI.downloadContactsCSV(payload);
      setShowDownloadModal(false);
      setImportSuccess(true);
      setTimeout(() => setImportSuccess(false), 3000);
    } catch (error) {
      console.error('Error downloading contacts CSV:', error);
      setErrorMessage(error.message || 'Failed to download contacts. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="bg-[#bbd4e6] pl-4 pr-4 pb-4 pt-4 rounded-lg">

      <div className={`flex justify-between ${userName === "USER" ? 'mb-4' : 'mb-0'}`}>
       <SearchBy 
        dropdownRef={dropdownRef}
        setShowDropdown={setShowDropdown}
        showDropdown={showDropdown}
        selectedSearchField={selectedSearchField}
        getSelectedOption={getSelectedOption}
        searchOptions={searchOptions}
        handleSearchFieldSelect={handleSearchFieldSelect}
        statusDropdownRef={statusDropdownRef}
        setShowStatusDropdown={setShowStatusDropdown}
        showStatusDropdown={showStatusDropdown}
        statusOptions={statusOptions}
        handleStatusSelect={handleStatusSelect}
        userTypeDropdownRef={userTypeDropdownRef}
        setShowUserTypeDropdown={setShowUserTypeDropdown}
        showUserTypeDropdown={showUserTypeDropdown}
        userTypeOptions={userTypeOptions}
        handleUserTypeSelect={handleUserTypeSelect}
        searchDate={searchDate}
        setSearchDate={setSearchDate}
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
        searchValue={searchValue}
        fetchContacts={fetchContacts}
        setSearchValue={setSearchValue}
        handleSearch={handleSearch}
        setSelectedSearchField={setSelectedSearchField}
        clearFilters={clearFilters}
      />


      <div className='flex justify-between'>
        {userName === 'ADMIN' && (
            <UserListDropdown usersDropdownRef={usersDropdownRef} setShowUsersDropdown={setShowUsersDropdown} showUsersDropdown={showUsersDropdown} selectedUserId={selectedUserId} handleUserSelect={handleUserSelect} clearUserFilter={clearUserFilter}  apiType="contact"/>
          )}

      

        <div className="flex max-h-[42px] gap-2">
          <button 
            onClick={() => setShowAddModal(true)}
            className="py-1 px-4 text-white rounded-md bg-[#3985b6] hover:bg-[#2b6a94]"
          >
            Add Contact
          </button>
          
          <button 
            onClick={() => setShowDownloadModal(true)}
            className="py-1 px-4 text-white rounded-md bg-[#3985b6] hover:bg-[#2b6a94] flex items-center gap-2"
            title="Download Contacts CSV"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            CSV
          </button>
          
          <button 
            onClick={() => setShowImportModal(true)}
            className="py-1 px-4 text-white rounded-md bg-green-600 hover:bg-green-700"
          >
            Import
          </button>
          
          <button 
            onClick={() => setShowCheckboxes(!showCheckboxes)}
            className={`py-1 px-4 text-[1rem] min-w-[120px] rounded-md ${
              showCheckboxes 
                ? 'bg-red-100 text-[#772e1c]' 
                : 'text-gray-700 bg-white'
            }`}
          >
            {showCheckboxes ? 'Cancel Update' : 'Batch Update'}
          </button>
          
          {showCheckboxes && getSelectedContactIds().length > 0 && (
          <div className="relative" ref={actionsDropdownRef}>
            <button 
              onClick={() => setShowActionsDropdown(!showActionsDropdown)}
              disabled={isUpdatingContacts}
              className="flex items-center justify-between min-w-32 py-[8px] px-4 text-[#3985b6] rounded-md bg-white border-2 border-[#3985b6] hover:bg-[#3985b6] hover:text-white ml-2 disabled:opacity-50"
            >
              <span>Actions ({getSelectedContactIds().length})</span>
              <svg
                className={`w-4 h-4 ml-2 transition-transform duration-200 ${showActionsDropdown ? 'transform rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {showActionsDropdown && (
              <div className="absolute top-full right-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-xl z-30 overflow-hidden">
                
                {/* Next Followup Call - Alternative */}
            <div className="relative">
              <div className="flex items-center justify-between px-4 py-3 hover:bg-gray-50 border-b border-gray-100">
                <span className="font-medium text-gray-700">Next Followup Call</span>
                <button
                  onClick={() => {
                    setShowFollowupCallCalendar(!showFollowupCallCalendar);
                    setShowFollowupMailCalendar(false);
                    setShowStatusSubDropdown(false);
                  }}
                  className="p-1 hover:bg-blue-100 rounded"
                >
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </button>
              </div>
          
              {showFollowupCallCalendar && (
                <div className="px-4 py-3 bg-blue-50 border-b  border-gray-100 flex gap-2">
                  <input
                    type="date"
                    value={followupCallDate}
                    onChange={(e) => setFollowupCallDate(e.target.value)}
                    className="flex-1 px-3 py-2 border border-gray-300 max-w-[160px] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                    min={new Date().toISOString().split('T')[0]}
                  />
                  <button
                    onClick={() => {
                      if (followupCallDate) {
                        handleDateSelect('nextFollowupCall', followupCallDate);
                        setFollowupCallDate('');
                      }
                    }}
                    disabled={!followupCallDate}
                    className="px-4 py-0 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Set
                  </button>
                </div>
              )}
            </div>

            {/* Next Followup Mail - Alternative */}
            <div className="relative">
              <div className="flex items-center justify-between px-4 py-3 hover:bg-gray-50 border-b border-gray-100">
                <span className="font-medium text-gray-700">Next Followup Mail</span>
                <button
                  onClick={() => {
                    setShowFollowupMailCalendar(!showFollowupMailCalendar);
                    setShowFollowupCallCalendar(false);
                    setShowStatusSubDropdown(false);
                  }}
                  className="p-1 hover:bg-blue-100 rounded"
                >
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </button>
              </div>
              
              {showFollowupMailCalendar && (
                <div className="px-4 py-3 bg-blue-50 border-b border-gray-100 flex gap-2">
                  <input
                    type="date"
                    value={followupMailDate}
                    onChange={(e) => setFollowupMailDate(e.target.value)}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
                    min={new Date().toISOString().split('T')[0]}
                  />
                  <button
                    onClick={() => {
                      if (followupMailDate) {
                        handleDateSelect('nextFollowupMail', followupMailDate);
                        setFollowupMailDate('');
                      }
                    }}
                    disabled={!followupMailDate}
                    className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Set
                  </button>
                </div>
              )}
            </div>

            {/* Status */}
            <div className="relative" ref={statusSubDropdownRef}>
              <button
                onClick={() => {
                  setShowStatusSubDropdown(!showStatusSubDropdown);
                  setShowFollowupCallCalendar(false);
                  setShowFollowupMailCalendar(false);
                }}
                className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 border-b border-gray-100"
              >
                <span className="font-medium text-gray-700">Status</span>
                <svg
                  className={`w-4 h-4 transition-transform duration-200 ${showStatusSubDropdown ? 'transform rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {showStatusSubDropdown && statusSubDropdownRef.current && (
              <>
                <div 
                  className="fixed inset-0" 
                  style={{ zIndex: 9998 }}
                  onClick={() => setShowStatusSubDropdown(false)}
                />
                
                <div 
                  className="fixed bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden"
                  style={{ 
                    marginRight:'60px',
                    zIndex: 9999,
                    minWidth: '200px',
                    top: Math.min(
                      statusSubDropdownRef.current.getBoundingClientRect().top,
                      window.innerHeight - 300
                    ) + 'px',
                    left: Math.min(
                      statusSubDropdownRef.current.getBoundingClientRect().right + 10,
                      window.innerWidth - 270
                    ) + 'px'
                  }}
                >
                  {statusOptions.map((status) => (
                    <button
                      key={status.value}
                      onClick={(e) => {
                        console.log('Status selected (positioned):', status);
                        e.stopPropagation();
                        handleStatusBulkSelect(status);
                        setShowStatusSubDropdown(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gradient-to-r hover:from-yellow-50 hover:to-blue-50 focus:outline-none transition-all duration-150 border-b border-gray-100 last:border-b-0"
                    >
                      <span className="font-medium text-gray-700">{status.label}</span>
                    </button>
                  ))}
                </div>
              </>
            )}
              </div>

              {/* Delete Option */}
              <button 
                onClick={() => {
                  setShowDeleteModal(true);
                  setShowActionsDropdown(false);
                }}
                className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 font-medium"
              >
                Delete Selected
              </button>
            </div>
          )}
        </div>
      )}
        </div>
      </div>
      </div>

      {Object.keys(activeFilters).length > 0 && (
        <div className="flex flex-wrap gap-2 pt-1 pb-3">
          {Object.entries(activeFilters).map(([key, value]) => (
            <div key={key} className="flex items-center bg-yellow-100 text-gray-800 px-4 py-0 rounded-full text-sm font-medium shadow-sm">
              <span className="mr-2">
                {searchOptions.find(opt => opt.value === key)?.label}: 
                <span className="font-semibold ml-1">
                  {key === 'status' ? getStatusLabel(value) : key === 'userType' ? getUserTypeLabel(value) : value}
                </span>
              </span>
              <button
                onClick={() => removeFilter(key)}
                className="ml-2 hover:text-red-600 font-bold text-lg transition-colors duration-150"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {isFetchingData ? (
        <div className="flex justify-center items-center py-10">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#3985b6]"></div>
        </div>
      ) : contacts.length === 0 ? (
        <div className="bg-white rounded-lg p-10 text-center">
          <p className="text-gray-500 text-lg">No contacts found.</p>
        </div>
      ) : (
        <ContactsTable
          contacts={contacts} 
          selectAll={selectAll} 
          handleSelectAll={handleSelectAll} 
          handleSelectContact={handleSelectContact} 
          updateContactStatus={updateContactStatus}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          showCheckboxes={showCheckboxes}
          activeFilters={activeFilters}
          fetchContacts={fetchContacts}
          currentLimit={limitt}             
          onLimitChange={handleLimitChange}  
          totalContacts={totalContacts} 
          setContacts={setContacts}
        />
      )}

      {showAddModal && (
        <div className="fixed inset-0 bg-[#000000] bg-opacity-50 backdrop-blur-[15px] flex items-center justify-center z-50">
          <AddContactForm 
            formData={formData}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            resetForm={resetForm}
            setShowAddModal={setShowAddModal}
            isLoading={isLoading}
          />
        </div>
      )}


      {showImportModal && (
        <ShowImportModal resetImportModal={resetImportModal} isImporting={isImporting} selectedFile={selectedFile} handleFileSelect={handleFileSelect} fileError={fileError} handleImportContacts={handleImportContacts} fileInputRef={fileInputRef} handleFileChange={handleFileChange}/>
      )}
      
      {importSuccess && (
      <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-green-100 text-green-800 px-6 py-3 rounded-md shadow-md text-center z-50 max-w-[90%] sm:max-w-md">
        ✅ Contacts imported successfully!
      </div>
    )}


      {showDuplicateModal && (
        <ShowDuplicateModal setShowDuplicateModal={setShowDuplicateModal} setDuplicateData={setDuplicateData} setImportSuccess={setImportSuccess} downloadDuplicates={downloadDuplicates}/>
      )}
      
      {showDeleteModal && (
        <ShowDeleteModal setShowDeleteModal={setShowDeleteModal} getSelectedContactIds={getSelectedContactIds} isDeleting={isDeleting} handleDeleteContacts={handleDeleteContacts}/>
      )}

      {showDownloadModal && (
        <DownloadReasonModal 
          isOpen={showDownloadModal}
          onClose={() => setShowDownloadModal(false)}
          onConfirm={handleDownloadCSV}
          isDownloading={isDownloading}
        />
      )}

      {errorMessage && (
      <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-100 text-red-800 px-6 py-3 rounded-md shadow-md text-center z-50 max-w-[90%] sm:max-w-md">
        {"❌  "+errorMessage}
      </div>
      )}

    </div>
  );
};

export default Contacts;